<template>
  <div class="voice_show">
    <div class="voice_center">
      <div class="voice_center_left">
        <div class="voice_text_info">
          <div class="title_box">
            <div>{{audioInfo.title}}</div>
            <span>{{audioInfo.publishTime}}</span>
          </div>
          <div class="audio_box">
            <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload"></audio>-->
            <ProgressBar :styles="{width:'750px', height:'80px'}" :url="audioInfo.url"></ProgressBar>
          </div>
          <div class="voice_text">
            <div>语音内容</div>
            <p v-html="audioInfo.content"></p>
          </div>
          <div class="recommend_list">
            <div class="title">相关推荐</div>
            <div class="recommendList_box">
              <div class="item_list" v-for="item in recommendList" :key="item.id" @click="handleAudioClick(item.id)">
                <div class="item_title">{{item.title}}</div>
                <div class="item_text">第一，是避免诱发的因素，什么叫避免诱发因素？引起过敏的因素是诱发因素，最重要的部分，比如有的宝宝是尘螨过敏</div>
                <div class="item_doctorAudio">
                  <img :src="item.coverUrl" alt="">
                  <div class="audio_boxTwo">
                    <Audio :styles="{width:'300px', height:'35px'}" :url="item.url"/>
                  </div>
                </div>
                <div class="item_doctorInfo">
                  <div class="doctorInfo_name">
                    <div>{{item.doctorName}}</div>
                    <span>{{item.doctorLevelName}}</span>
                  </div>
                  <div class="doctorInfo_hospital">{{item.hospitalName}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="voice_center_right">
        <div class="doctor_info">
          <img :src="audioInfo.headImage" alt="">
          <div class="doctor_name">
            <div>{{audioInfo.doctorName}}</div>
            <span>{{audioInfo.doctorLevelName}}</span>
          </div>
          <div class="doctor_Hospital">
            <div>{{audioInfo.hospitalName}}</div>
            <span>{{audioInfo.departmentName}}</span>
          </div>
          <div class="doctor_introduce">{{audioInfo.doctorSkill}}</div>
        </div>
        <div class="hot_voiceRight_box">
          <div class="hot_voiceRight_title">热点关注</div>
          <div class="KPVoice_card_right">
            <div class="item_voiceList" v-for="item in HotaudioData" :key="item.id" @click="handleAudioClick(item.id)">
              <div class="GraphicText_list">
                  <div class="item_GraphicText_list">
                    <div class="GraphicImg">
                      <img :src="item.coverUrl" alt="">
                    </div>
                    <div class="textTime">
                      <div class="text_jieshao">{{item.title}}</div>
                      <div class="text_bottom">
                        <div class="name">
                          <div>{{item.doctorName}}</div>
                          <span class="title">{{item.doctorLevelName}}</span>
                        </div>
                        <img src="../../assets/images/home/shengyin.png" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              <div class="hot_list">
                <div class="item_hot_list">
                  <div class="joint_box">
                    <img src="../../assets/images/home/left_img.png" alt="">
                  </div>
                  <div class="hot_text">{{item.title}}</div>
                  <img src="../../assets/images/home/shengyin.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Audio from '../../components/audio/Index'
  import ProgressBar from '../../components/audio/ProgressBar.vue'
  export default {
    components:{
      Audio,
      ProgressBar
    },
    data(){
      return {
        audioInfo:{},
        recommendList:[],
        HotaudioData:[],
      }
    },
    methods:{
      getAudio(){
        let audios = document.getElementsByTagName("Audio");
        // 暂停函数
        function pauseAll() {
          var self = this;
          [].forEach.call(audios, function (i) {
            // 将audios中其他的audio全部暂停
            i !== self && i.pause();
          })
        }
        // 给play事件绑定暂停函数
        [].forEach.call(audios, function (i) {
          i.addEventListener("play", pauseAll.bind(i));
        })
      },
      // 获取详情信息
      getVideoShow() {
        let params = {
          id:this.$route.params.id
        }
        this.$api.mykp_home.findVideoShow(params) .then(res => {
          if(res.code == '000000') {
            // if(!this.audioInfo.doctorId){
            //   this.audioInfo = res.infos
            //   this.getHotAudioList()
            // }
            this.audioInfo = res.infos

          }
        })
      },
      // 获取相关推荐列表
      getGoodList() {
        let params = {
          page:1,
          size:4,
          id:this.$route.params.id
        }
        this.$api.mykp_home.findGoodList(params) .then(res => {
          if(res.code == '000000') {
            this.recommendList  = res.infos
            this.$nextTick(() => {
              this.getAudio()
            })
          }
        })
      },
      // 获取热点语音列表
      getHotAudioList() {
        const data = {
          type:2,
          doctorId:0
        }
        this.$api.mykp_home.findDetailsHotlist(data) .then(res => {
          if(res.code == '000000'){
            this.HotaudioData = res.infos
          }
        })
      },
      // 点击音频
      handleAudioClick(id) {
        this.$router.push({path:'/kpVoice/kpVoiceShow/'+id,query:{}})
      },
    },
    activated() {
      this.getAudio()
      this.getVideoShow()
      this.getGoodList()
      this.getHotAudioList()
       var _hmt = _hmt || [];
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?26e3d1e8dc2b426ced392180fb72861b";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
      console.log("统计")
    },
    // 调用当前组件时调用
    beforeRouteUpdate (to, from, next) {
      next()
      this.getAudio()
      this.getVideoShow()
      this.getGoodList()
      this.getHotAudioList()
      var _hmt = _hmt || [];
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?26e3d1e8dc2b426ced392180fb72861b";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
      console.log("统计")
    },

  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .voice_show{
    width: 1200px
    margin  0 auto
    .voice_center{
      margin-top 40px
      display flex
      justify-content space-between
      .voice_center_left{
        width: 811px
        .voice_text_info{
          .title_box{
            &:after{
              content:''
              display block
              width: 100%
              height: 1px
              background #eee
              margin-top 10px
            }
            >div{
              font-weight: 700;
              font-size: 20px;
              color: #333
              text-align: center
            }
            >span{
              margin-top 20px
              display block
              font-size: 12px;
              color: #C9C9C9;
              text-align: right
            }
          }
          .audio_box{
            margin-top 40px
            width: 800px
            height: 110px
            border-radius: 9px;
            border:1px solid #d7d7d7
            display flex
            align-items center
            justify-content center
            >audio{
              width: 750px
              /*height: 80px*/
              outline none
            }
          }
          .voice_text{
            margin-top 30px
            font-size: 16px;
            line-height: 24px;
            color: #333
            >div{
              font-weight: 700;
              font-size: 20px;
              color: #333
              margin-bottom 20px
            }
            >p{
              font-size: 16px;
              line-height: 24px;
              color: #333
              text-indent 2em
              margin-bottom 20px
            }
          }
          .recommend_list{
            .title{
              font-weight: 700;
              font-size: 20px;
              color: #333
              margin 40px 0
            }
            .recommendList_box{
              .item_list{
                cursor: pointer
                &:after{
                  content: ''
                  display block
                  width: 100%
                  height: 1px
                  background #ededed
                  margin 20px 0
                }
                .item_title{
                  font-weight: 700;
                  font-style: normal;
                  font-size: 18px;
                  color: #333
                }
                .item_text{
                  margin-top 10px
                  font-size: 14px;
                  line-height: 24px;
                  color: #333
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
                .item_doctorAudio{
                  margin 15px 0
                  display flex
                  align-items center
                  >img{
                    width: 60px;
                    height: 60px;
                    border-radius 50%
                    margin-right 20px
                  }
                  .audio_boxTwo{
                    height: 35px;
                    >audio{
                      width: 300px;
                      height: 35px;
                    }
                  }
                }
                .item_doctorInfo{
                  display flex
                  align-items center
                  .doctorInfo_name{
                    margin-right 20px
                    display flex
                    align-items center
                    >div{
                      font-size: 14px;
                      color: #000000;
                      margin-right 5px
                    }
                    >span{
                      font-size: 14px;
                      color: #000000;
                    }
                  }
                  .doctorInfo_hospital{
                    font-size: 14px;
                    color: #000000;
                  }
                }
              }
            }
          }
        }
      }
      .voice_center_right{
        width: 350px
        .doctor_info{
          display flex
          flex-direction column
          align-items center
          >img{
            width: 100px;
            height: 100px;
            border-radius 50%
          }
          .doctor_name{
            display flex
            margin-top 25px
            >div{
              font-weight: 700;
              font-style: normal;
              font-size: 18px;
              color: #000000;
              margin-right 25px
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width 150px
            }
            >span{
              font-size: 18px;
              color: #000000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width 150px
            }
          }
          .doctor_Hospital{
            display flex
            margin-top 10px
            >div{
              font-size: 16px;
              color: #000000;
              margin-right 20px
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width 150px
            }
            >span{
              font-size: 16px;
              color: #000000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width 150px
            }
          }
          .doctor_introduce{
            margin-top 10px
            color: #5E5E5E;
            font-size: 12px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 22px
          }
        }
        .hot_voiceRight_box{
          margin-top 50px
          .hot_voiceRight_title{
            font-weight: 700;
            font-style: normal;
            font-size: 20px;
            color: #333
          }
          .KPVoice_card_right{
            margin-top 20px
            width: 350px
            .item_voiceList{
              cursor: pointer
              &:nth-child(-n +3){
                .GraphicText_list{
                  display flex
                }
                .hot_list{
                  display none
                }
              }
              &:nth-child(3) {
                &:after{
                  content: ''
                  display block
                  width 100%
                  height 1px
                  margin 26px 0 26px 0
                  border-top 1px dashed #eee
                }
              }
              .GraphicText_list{
                margin-bottom 16px
                display none
                flex 1
                .item_GraphicText_list{
                  cursor: pointer
                  display flex
                  .GraphicImg{
                    >img{
                      width: 100px
                      height: 70px
                      margin-right 15px
                    }
                  }
                  .textTime{
                    height: 70px
                    display flex
                    flex-direction column
                    justify-content space-around
                    .text_jieshao{
                      color: #5E5E5E
                      font-size 14px
                      text-overflow: -o-ellipsis-lastline;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      line-height 18px
                    }
                    .text_bottom{
                      display flex
                      justify-content space-between
                      align-items  center
                      .name{
                        display flex
                        align-items center
                        >div{
                          font-weight: 700;
                          font-size: 18px;
                          color: #000000;
                          margin-right 20px
                          width 60px
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                        .title{
                          font-size: 14px;
                          color: #000000;
                          width 100px
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                      }
                      >img{
                        width: 20px
                        height: 20px
                      }
                    }
                  }
                }
              }
              .hot_list{
                margin-bottom 16px
                .item_hot_list{
                  display flex
                  align-items center
                  .joint_box{
                    >img{
                      vertical-align middle
                    }
                  }
                  .hot_text{
                    font-size: 14px;
                    color: #5E5E5E;
                    margin-left 12px
                    width: 100%
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  >img{
                    width: 20px
                    height: 20px
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/kpVoice/Show.vue